import {
  useCallback,
} from 'react';

import type {
  CreateClientInput,
} from '@/types/client';

import type {
  ClientDuplicateCandidate,
} from '@/lib/clientDuplicateDecision';

type DuplicateCheckResponse = {
  success: boolean;

  duplicates:
    ClientDuplicateCandidate[];

  hasStrongDuplicate:
    boolean;

  hasPossibleDuplicate:
    boolean;

  error?:
    string;
};

export function useClientDuplicateCheck() {
  const checkClientDuplicates =
    useCallback(
      async (
        input:
          CreateClientInput,

        excludeClientId?:
          string |
          null
      ) => {
        const params =
          new URLSearchParams();

        if (
          input.name?.trim()
        ) {
          params.set(
            'name',
            input.name.trim()
          );
        }

        if (
          input.cpfCnpj?.trim()
        ) {
          params.set(
            'document',
            input.cpfCnpj.trim()
          );
        }

        if (
          input.phone?.trim()
        ) {
          params.set(
            'phone',
            input.phone.trim()
          );
        }

        if (
          input.email?.trim()
        ) {
          params.set(
            'email',
            input.email.trim()
          );
        }

        if (
          excludeClientId?.trim()
        ) {
          params.set(
            'excludeClientId',
            excludeClientId.trim()
          );
        }

        if (
          params.size === 0
        ) {
          return {
            success:
              true,

            duplicates:
              [],

            hasStrongDuplicate:
              false,

            hasPossibleDuplicate:
              false,
          } satisfies DuplicateCheckResponse;
        }

        const response =
          await fetch(
            `/api/client-duplicates?${params.toString()}`,
            {
              method:
                'GET',

              headers: {
                Accept:
                  'application/json',
              },
            }
          );

        const data =
          await response
            .json() as
              DuplicateCheckResponse;

        if (
          !response.ok ||
          !data.success
        ) {
          throw new Error(
            data.error ||
            'Não foi possível verificar possíveis duplicidades.'
          );
        }

        return {
          success:
            true,

          duplicates:
            Array.isArray(
              data.duplicates
            )
              ? data.duplicates
              : [],

          hasStrongDuplicate:
            Boolean(
              data.hasStrongDuplicate
            ),

          hasPossibleDuplicate:
            Boolean(
              data.hasPossibleDuplicate
            ),
        } satisfies DuplicateCheckResponse;
      },
      []
    );

  return {
    checkClientDuplicates,
  };
}